/**
 * Constantes UI du module KPI consolidés. La liste COMPANIES est le miroir
 * exact de celle côté serveur (mappings.ts) — dupliquée volontairement
 * pour que le feature folder client reste autonome (aucun import cross-
 * server/client côté bundle Vite).
 */

export const COMPANIES = [
  'SOLLY AZAR',
  'ZEPHIR',
  'MAXANCE',
  'KLIAN',
  'APRIL COLLECTION',
  'APRIL PARTENAIRES',
  'APRIL MOTO',
  'APRIL SANTE',
  'APRIL MARINE',
  'APRIL ENTREPRISE',
  'APRIL INTERNATIONAL',
  'APRIL QBE',
  'NOVELIA',
  'FINISTERE',
  'FMA',
  'EURODOMMAGES',
  'NETVOX',
  'GENERALI',
  'CARENE',
  'AXA',
  'AXA VSP',
  'ALLIANZ',
  'ALPTIS ASSURANCES',
  'JP LABALETTE',
  'SWISSLIFE',
  'ENTORIA',
  'PROGEAS',
  'OYAT',
  'SERENIS ASSURANCES',
  'XENASSUR',
  'WAZARI',
  'LEOCARE',
  'HELVETIA',
  'CMAM',
  'AGPM',
  'ALBINGIA',
  'LSA ASSURANCES',
  'BEST ASSURANCES',
  'FB TEMPORAIRE PARIS',
  'CFDP',
  'AMI3F',
  'M COMME MUTUELLE',
  'MILLENNIUM LEADER UNDERWRITING',
  'GTA SEMEUSE',
  'AYDOO',
  'HFCA',
  'UTWIN',
  'ADD VALUE',
  'GIEPS',
  'ASAF GIEPS',
  'COVEA',
  'DAS',
  'RCB',
  'EQUICOURTAGE',
  'AIRBAG',
  'TETRIS',
  'SATEC',
  'ASSUREVER',
  'ELOIS',
  'PLUS SIMPLE',
  'RETRO ASSURANCES',
  'MONDIAL ASSISTANCE',
  'EUROP ASSISTANCE',
  'LA MUTUELLE DES MOTARDS',
  'AIG',
  'Autre',
] as const;

/**
 * Palette verte pour la page KPI consolidés (souscriptions). Valeurs hex
 * en dur car Recharts ne peut pas lire les CSS variables depuis ses props
 * `fill` / `stroke`. Cf SPEC-PORT.md §7.3.
 *
 * - `accent`    : couleur principale des courbes/barres (#10b981, vert)
 * - `accentN1`  : courbe N-1 (vert plus clair #6ee7b7)
 * - `top0/top1/topRest` : barres top compagnies (shades de vert décroissants)
 * - `pie`       : 14 couleurs ordonnées pour le donut (distinctes visuellement)
 * - `ventilation` : 3 couleurs de la carte ventilation apporteurs
 */
export const PALETTE = {
  accent: '#10b981',
  accentN1: '#6ee7b7',
  topBar: {
    rank0: '#10b981',
    rank1: '#34d399',
    rest: '#a7f3d0',
  },
  pie: [
    '#10b981',
    '#34d399',
    '#6ee7b7',
    '#a7f3d0',
    '#22d3ee',
    '#06b6d4',
    '#0ea5e9',
    '#3b82f6',
    '#8b5cf6',
    '#a78bfa',
    '#f59e0b',
    '#f97316',
    '#ef4444',
    '#64748b',
  ],
  ventilation: {
    avecApporteur: '#10b981',
    sansApporteur: '#8898aa',
    apporteurParraine: '#635bff',
  },
} as const;

/** Abbreviations mois pour les labels charts (FR court). */
export const MONTH_ABBR = [
  'Jan',
  'Fév',
  'Mar',
  'Avr',
  'Mai',
  'Juin',
  'Juil',
  'Août',
  'Sep',
  'Oct',
  'Nov',
  'Déc',
] as const;

/** Cache client TTL (20 min). Aligné SPEC-PORT.md §5.1. */
export const CLIENT_CACHE_TTL_MS = 20 * 60 * 1000;
